import { __awaiter, __generator } from "tslib";
import { getUserStorageItem, setUserStorageItem, } from '@office-start/user-storage-service';
import { getUserItem as getLocalStorageUserItem, setUserItem as setLocalStorageUserItem, } from '@office-start/web-storage-utility';
import { filterPriorityData } from '../helpers/filterPriorityData';
import { getLocalStorageKey } from '../helpers/getLocalStorageKey';
export function getFirstRunStateFromStorageAndSync(options, identity, storageKey, skipUserStorage) {
    return __awaiter(this, void 0, void 0, function () {
        var cacheState, networkState, firstRunState, dataInBothStorageSourcesButOutOfSync, shouldUpdateUserStorage, shouldUpdateLocalStorage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cacheState = getLocalStorageUserItem(identity.puid, "_".concat(storageKey)) || null;
                    if (skipUserStorage) {
                        return [2 /*return*/, cacheState];
                    }
                    return [4 /*yield*/, getUserStorageItem(storageKey, options)];
                case 1:
                    networkState = (_a.sent()) || null;
                    firstRunState = filterPriorityData(networkState, cacheState);
                    dataInBothStorageSourcesButOutOfSync = networkState &&
                        cacheState &&
                        (networkState.CompletedFirstRun !== cacheState.CompletedFirstRun ||
                            networkState.Version !== cacheState.Version);
                    shouldUpdateUserStorage = firstRunState &&
                        (networkState === null || dataInBothStorageSourcesButOutOfSync);
                    shouldUpdateLocalStorage = firstRunState &&
                        (cacheState === null || dataInBothStorageSourcesButOutOfSync);
                    if (shouldUpdateUserStorage) {
                        setUserStorageItem(storageKey, firstRunState, options);
                    }
                    if (shouldUpdateLocalStorage) {
                        setLocalStorageUserItem(identity.puid, getLocalStorageKey(storageKey), firstRunState);
                    }
                    return [2 /*return*/, firstRunState];
            }
        });
    });
}
//# sourceMappingURL=getFirstRunStateFromStorageAndSync.js.map